var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-5 h-5 text-xs font-semibold flex items-center justify-center",class:_vm.square ? 'rounded' : 'rounded-full',staticStyle:{"font-size":"10px"},style:(`background-color: ${_vm.colour.value}; color: ${_vm.colour.dark ? 'white' : 'black'};`),attrs:{"title":_vm.spec.title},domProps:{"textContent":_vm._s(_vm.initials)}})
}
var staticRenderFns = []

export { render, staticRenderFns }